import { Link } from "react-router-dom";
import OddsCell from "./OddsCell";

const slot = (book, i) => book?.[i] || {};

export default function MatchRow({ m, onPick }) {
  const [a, b] = m.teams || [];
  const book = m.book || [];
  const live = m.status === "live";
  const pick = (i, side) => {
    const s = slot(book, i);
    onPick?.({ matchId: m.id, match: m.name, selection: s.selection, side, price: s[side] });
  };
  return (
    <Link
      to={`/match/${m.id}`}
      data-testid={`match-row-${m.id}`}
      className="grid grid-cols-12 items-center gap-2 px-3 py-2.5 border-b border-zinc-800 hover:bg-zinc-900/70 transition-colors"
    >
      <div className="col-span-12 md:col-span-5 flex items-center gap-3 min-w-0">
        <div className="w-14 shrink-0 text-center">
          {live ? (
            <span className="inline-block text-[10px] font-bold bg-red-500 text-white rounded px-1.5 py-0.5 pulse-live">LIVE</span>
          ) : (
            <span className="text-[11px] text-zinc-400 font-mono-stat">
              {m.date ? new Date(m.date).toLocaleString([], { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "--"}
            </span>
          )}
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold truncate">
            {a?.name} <span className="text-zinc-500">v</span> {b?.name}
          </div>
          <div className="text-[11px] text-zinc-400 truncate">
            {m.competition} · {m.format}
            {(a?.score || b?.score) && (
              <span className="text-amber-300 font-mono-stat ml-2">
                {a?.score || "–"} | {b?.score || "–"}
              </span>
            )}
          </div>
        </div>
        {m.sample && (
          <span className="ml-auto text-[9px] uppercase tracking-wider border border-amber-500/40 text-amber-300 rounded px-1" data-testid="sample-badge">
            Sample
          </span>
        )}
      </div>
      <div className="col-span-12 md:col-span-7 grid grid-cols-6 gap-1">
        {[0, 1, 2].map((i) => (
          <div key={i} className="col-span-2 grid grid-cols-2 gap-1">
            <OddsCell price={slot(book, i).back} side="back" onPick={() => pick(i, "back")} testid={`odds-${m.id}-${i}-back`} />
            <OddsCell price={slot(book, i).lay} side="lay" onPick={() => pick(i, "lay")} testid={`odds-${m.id}-${i}-lay`} />
          </div>
        ))}
      </div>
    </Link>
  );
}
